export default class QuoteSlider {

    /**
     * @param   {Element} element
     */
    constructor(element) {
        /**
         * @type {Element}
         * @private
         */
        this._container = element;

        /**
         * @type {NodeListOf<Element>}
         */
        this.slides = this._container.querySelectorAll('.slide');

        /**
         * @type {number}
         */
        this.index = 0;

        /**
         * @type {NodeListOf<Element>}
         */
        this._inner = this._container.querySelector('.inner');

        /**
         * @type {NodeListOf<Element>}
         */
        this._control = this._container.querySelectorAll('.slider-navigation__item');
    }

    init() {
        $(this._inner).css("height", this.slides[this.index].offsetHeight + 'px');

        $(this.slides[this.index]).addClass("-is-active");
        $(this._control[this.index]).addClass("-is-active");
        const self = this;

        this._control.forEach(function(button){

            button.addEventListener('click', () => {

                if(self.index !== $(button).index()) {
                    $(self.slides[self.index]).removeClass("-is-active");
                    $(self._control[self.index]).removeClass("-is-active");

                    self.index = $(button).index();
                    self.slide();
                }
            });
        });

        window.addEventListener('resize', () => {
            this.calculateAndSetInnerHeight();
        });
    }

    calculateAndSetInnerHeight() {
        this._inner.style.height = this.slides[this.index].offsetHeight + 'px';
    }

    slide() {
        $(this.slides[this.index]).addClass("-is-active");
        $(this._control[this.index]).addClass("-is-active");

        this.calculateAndSetInnerHeight();
    }
}
